import React from 'react';

const brands = [
  { src: '/assets/imgs/brands/brand-google.png',      alt: 'Google',      height: 48 },
  { src: '/assets/imgs/brands/brand-adobe.png',       alt: 'Adobe',       height: 62 },
  { src: '/assets/imgs/brands/brand-getir.png',       alt: 'Getir',       height: 62 },
  { src: '/assets/imgs/brands/brand-hepsiburada.png', alt: 'Hepsiburada', height: 36 },
  { src: '/assets/imgs/brands/brand-imunify360.png',  alt: 'Imunify360',  height: 48 },
  { src: '/assets/imgs/brands/brand-cpanel.png',      alt: 'cPanel',      height: 48 },
];

function Clients() {
  return (
    <section className="clients-carso section-padding pt-0">
      <div className="container">
        <div className="row justify-content-center">
          <div className="col-lg-6 col-md-10">
            <div className="sec-head text-center mb-80">
              <h3>
                Farklı sektörlerden <br />
                <span className="opacity-7">birçok markayla çalışmaktan gurur duyuyoruz.</span>
              </h3>
            </div>
          </div>
        </div>
        <div className="d-flex align-items-center justify-content-center flex-wrap" style={{ gap: '60px' }}>
          {brands.map((b, i) => (
            <img
              key={i}
              src={b.src}
              alt={b.alt}
              style={{ height: `${b.height}px`, width: 'auto', objectFit: 'contain', mixBlendMode: 'screen' }}
            />
          ))}
        </div>
      </div>
    </section>
  );
}

export default Clients;
